// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1kLvu","log":"ModalInventoryLogs_log__H7qpZ","date":"ModalInventoryLogs_date__3JH1Q","userName":"ModalInventoryLogs_userName__387XC"};